var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "list-container", style: { height: _vm.height } },
    [
      _c(
        "div",
        { staticClass: "toolbar" },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.add } },
            [_vm._v("添加自取货骑手")]
          ),
          _c(
            "el-input",
            {
              style: { width: "250px", float: "right" },
              attrs: { placeholder: "查询关键字", clearable: true },
              model: {
                value: _vm.keyword,
                callback: function ($$v) {
                  _vm.keyword = $$v
                },
                expression: "keyword",
              },
            },
            [
              _c("el-button", {
                attrs: { slot: "append", icon: "el-icon-search" },
                on: { click: _vm.search },
                slot: "append",
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          ref: "table",
          attrs: {
            data: _vm.riderList,
            "highlight-current-row": "",
            "max-height": _vm.tableMaxHeight,
            size: "mini",
            "row-class-name": _vm.tableRowClassName,
          },
          on: { "sort-change": _vm.handleSortChange },
        },
        [
          _c("el-table-column", {
            attrs: {
              label: "序号",
              type: "index",
              align: "center",
              width: "60px",
              index: _vm.getIndex,
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: "姓名",
              align: "left",
              width: "100px",
              prop: "cName",
              sortable: "custom",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: "性别",
              align: "center",
              width: "80px",
              prop: "bSex",
              sortable: "custom",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(" " + _vm._s(_vm.getSex(scope.row.bSex)) + " "),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "手机号码",
              align: "center",
              width: "150px",
              prop: "cPhone",
              sortable: "custom",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: "所在门店",
              align: "left",
              width: "300px",
              prop: "sStore",
              sortable: "custom",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: "更新时间",
              align: "center",
              width: "140px",
              prop: "tCreate",
              formatter: _vm.dateFormatter,
              sortable: "custom",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: "状态",
              align: "center",
              width: "80px",
              prop: "bStatus",
              sortable: "custom",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "span",
                      {
                        style: { color: _vm.getStatusColor(scope.row.bStatus) },
                      },
                      [_vm._v(_vm._s(_vm.getStatus(scope.row.bStatus)))]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { fixed: "right", align: "center", label: "操作" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.view(scope.row)
                          },
                        },
                      },
                      [_vm._v("详情")]
                    ),
                    _c(
                      "el-popconfirm",
                      {
                        attrs: {
                          "confirm-button-text": "确定",
                          "cancel-button-text": "取消",
                          icon: "el-icon-info",
                          "icon-color": "red",
                          title: "是否确认删除数据项？",
                        },
                        on: {
                          confirm: function ($event) {
                            return _vm.deleteData(scope.row)
                          },
                        },
                      },
                      [
                        _c(
                          "el-button",
                          {
                            style: {
                              color: "rgb(241, 106, 106)",
                              marginLeft: "5px",
                            },
                            attrs: { slot: "reference", type: "text" },
                            slot: "reference",
                          },
                          [_vm._v("移除")]
                        ),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("el-pagination", {
        style: { marginTop: "15px" },
        attrs: {
          background: "",
          layout: _vm.pageLayout,
          total: _vm.total,
          "current-page": _vm.pageNum,
          "page-sizes": _vm.pageSelect,
          "page-size": _vm.pageSize,
        },
        on: {
          "size-change": _vm.handleSizeChange,
          "current-change": _vm.handleCurrentChange,
        },
      }),
      _c("AddSelfPickupGoodsRider", {
        attrs: { visible: _vm.showAddSelfPickupGoodsRider },
        on: {
          "update:visible": function ($event) {
            _vm.showAddSelfPickupGoodsRider = $event
          },
          close: _vm.handleCloseAddSelfPickupGoodsRider,
        },
      }),
      _c("ViewRiderDetail", {
        attrs: { visible: _vm.showViewRiderDetail, sid: _vm.currentRiderSid },
        on: {
          "update:visible": function ($event) {
            _vm.showViewRiderDetail = $event
          },
          close: _vm.handleCloseViewRiderDetail,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }